import { render, staticRenderFns } from "./DefaultTextarea.vue?vue&type=template&id=7822e088"
import script from "./DefaultTextarea.vue?vue&type=script&lang=js"
export * from "./DefaultTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports